import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import { handleDownloadCSV } from "../../../../utils/CsvDownload";

const Table = ({
  TableData = [],
  setTableData = () => {},
}) => {
  const tableRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowsPerPage] = useState(10);

  const isAllSelected = TableData.length > 0 && selectedRows.length === TableData.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = TableData.slice(indexOfFirstRow, indexOfLastRow);

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = TableData.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (index) => {
    const updated = [...TableData];
    updated[index].is_verified = !updated[index].is_verified;
    setTableData(updated);
  };

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    cols?.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["S.No", "Delivery Note", "Invoice No.", "Box Id", "Box Weight", "Is Verified"].map((title, i) => {
              const defaultWidths = {
                "Action": "20px",
                "S.No": "20px",
                "Delivery Note": "110px",
                "Invoice No.": "110px",
                "Box Id": "150px",
                "Box Weight": "100px",
                "Is Verified ?": "100px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: '15px',
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="text-center">{globalIndex + 1}</td>
                <td className="text-center">{row.delivery_note}</td>
                <td className="text-center">{row.sales_invoice}</td>
                <td className="text-center">{row.name}</td>
                <td className="text-center">{row.gross_weight_pkg}</td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={row.is_verified}
                    onChange={() => handleCheckboxChange(globalIndex)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Footer Section */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {TableData.length > 0 && (
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="MdOutlineFileDownload"
              iconSize={12}
              onClick={() => {
                handleDownloadCSV(
                  ["S.No", "Delivery Note", "Invoice No.", "Box Id", "Box Weight", "Is Verified"],
                  TableData.map((row, i) => ({
                    sno: i + 1,
                    delivery_note: row.delivery_note,
                    invoice_no: "-",
                    name: row.name,
                    gross_weight_pkg: row.gross_weight_pkg,
                    is_verified: row.is_verified ? "Yes" : "No",
                  })),
                  "packing-slips"
                );
              }}
            >
              Download
            </Button>
          )}
        </div>

        {/* Pagination */}
        <div className={`${TableData.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={TableData.length}
          />
        </div>

        <div className={`${TableData.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, TableData.length)} of {TableData.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default Table;
